'use strict';

angular.module('licensure.services')
    .factory('LicenseCharges', ['$http', '$q', '$filter', 'LicenseChargeTypes', 'LicenseRequestCharges', 'FBQuestionCriteria', 'Logger', 'LicenseChargeCalculatedFields', function ($http, $q, $filter, LicenseChargeTypes, LicenseRequestCharges, FBQuestionCriteria, Logger, LicenseChargeCalculatedFields) {
        var get = function (args) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/licensecharges/', {
                    params: args
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        var calculateChargeType = function (chargeTypeId, charge, licenseRequestID) {
            var d = $q.defer();

            LicenseChargeTypes.getCountFromQuery(chargeTypeId, licenseRequestID).then(function (count) {
                var amount = 0.0;

                if (count != null) {
                    count = count.record_count;
                    if (count >= 0 && count <= charge.threshold) {
                        amount = charge.value;
                    } else if (count > charge.threshold) {
                        amount = charge.value + ((count - charge.threshold) * charge.additional_charge);
                    }
                }
                // Save the charge to the license_request_charges table. The save function handles duplicate prevention
                if (amount != 0.0) {
                    var applicationCharge = {
                        name: charge.name,
                        value: amount,
                        license_request_id: licenseRequestID,
                        license_charge_id: charge.id
                    }
                    LicenseRequestCharges.save(applicationCharge).then(function (c) {
                        d.resolve(c != null);
                    });
                }
                else {
                    d.resolve(true);
                }
            })

            return d.promise;
        }

        return {
            get: get,

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensecharges/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_charge) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licensecharges/';
                if (!isUndefined(license_charge.id)) {
                    method = 'PUT';
                    url += license_charge.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_charge: license_charge
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function (id) {
                var d = $q.defer();

                $http.delete(apiLocation + '/api/licensecharges/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            evaluate: function (licenseID, responseID, licenseRequestID, datapointAnswers) {
                var d = $q.defer();

                get({ licenseID: licenseID, licenseRequestID: licenseRequestID }).then(function (charges) {
                    if (charges != null) {
                        var success = true;
                        var promises = [];

                        charges.forEach(function (charge) {
                            if (charge.flat_fee == 0) {
                                // Type
                                if (charge.license_charge_type != null) {

                                    if (charge.license_charge_type.data_point_id == null) {
                                        promises.push(calculateChargeType(charge.license_charge_type.id, charge, licenseRequestID).then(function (result) {
                                            if (!result) {
                                                success = false;
                                            }
                                        }));

                                    } else {
                                        var allAnswers = [];
                                        var matchingAnswers = [];
                                        if (datapointAnswers != null && datapointAnswers[charge.license_charge_type.datapoint.code] != null) {
                                            allAnswers = datapointAnswers[charge.license_charge_type.datapoint.code];
                                            // filter out answers with null values, they don't count
                                            allAnswers = $filter('filter')(allAnswers, function(answer) {return answer.value != null});
                                        }
                                        if (charge.license_charge_type.column_values != null) {
                                            charge.license_charge_type.column_values = charge.license_charge_type.column_values.toLowerCase().split(',');
                                            if (charge.license_charge_type.column_values.indexOf("1") > -1) {
                                                charge.license_charge_type.column_values.push("true");
                                            }
                                            if (charge.license_charge_type.column_values.indexOf("0") > -1) {
                                                charge.license_charge_type.column_values.push("false");
                                            }
                                            // count up the answers that match one of the values
                                            allAnswers.forEach(function (answer) {
                                                if (answer != null && answer.value != null && charge.license_charge_type.column_values.indexOf(answer.value.toString().toLowerCase()) > -1) {
                                                    matchingAnswers.push(answer);
                                                }
                                            });
                                        } else {
                                            matchingAnswers = allAnswers;
                                        }

                                        var amount = 0.0;
                                        var count = matchingAnswers.length;
                                        if (count > 0 && count <= charge.threshold) {
                                            amount = charge.value;
                                        } else if (count > 0) {
                                            amount = charge.value + ((count - charge.threshold) * charge.additional_charge);
                                        }
                                        // Save the charge to the license_request_charges table. The save function handles duplicate prevention
                                        if (amount != 0.0) {
                                            var applicationCharge = {
                                                name: charge.name,
                                                value: amount,
                                                license_request_id: licenseRequestID,
                                                license_charge_id: charge.id
                                            }
                                            promises.push(LicenseRequestCharges.save(applicationCharge).then(function (c) {
                                                if (c == null) {
                                                    success = false;
                                                }
                                            }));
                                        }
                                    }
                                }

                            } else if (charge.flat_fee == 1) {
                                // Flat
                                // flat doesn't need any special logic here - they're pulled in directly on checkout
                            } else if (charge.flat_fee == 2) {
                                // Conditional
                                var result = FBQuestionCriteria.evaluateCondition(charge);
                                if (result != null) {
                                    if (result) {
                                        // Save the charge to the license_request_charges table. The save function handles duplicate prevention
                                        if (charge.value != 0.0) {
                                            var applicationCharge = {
                                                name: charge.name,
                                                value: charge.value,
                                                license_request_id: licenseRequestID,
                                                license_charge_id: charge.id
                                            }
                                            promises.push(LicenseRequestCharges.save(applicationCharge).then(function (c) {
                                                if (c == null) {
                                                    success = false;
                                                }
                                            }));
                                        }
                                    }
                                }
                                else {
                                    success = false;
                                }
                            } else if (charge.flat_fee == 3) {
                                //Calculated Field
                                var calculatedValue = 0.0;
                                var returnedPromise = LicenseChargeCalculatedFields.getCalculatedValue(charge.calculated_field_question_id, charge.value, responseID);
                                returnedPromise.then(function (value) {
                                    calculatedValue = value;
                                    if (calculatedValue != 0.0) {
                                        var applicationCharge = {
                                            name: charge.name,
                                            value: calculatedValue,
                                            license_request_id: licenseRequestID,
                                            license_charge_id: charge.id
                                        }
                                        promises.push(LicenseRequestCharges.save(applicationCharge).then(function (charge) {
                                            if (charge == null) {
                                                success = false;
                                            }
                                        }));
                                    }
                                });
                            }
                        })

                        $q.all(promises).then(function () {
                            Logger.logFormProgress("Calculated Charges", responseID);
                            d.resolve(success);
                        }).catch(function (response) {
                            // handle error
                        });
                    }
                    else {
                        Logger.logFormProgress("Calculated Charges (none)", responseID);
                        d.resolve(false);
                    }
                })

                return d.promise;
            }
        }
    }])
    ;